module.exports = __webpack_public_path__ + "static/media/Rock Star.08f29af4.jpg";